import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import TouchButton from "../../atoms/TouchButton/TouchButton";
import InputSelect from "../../atoms/InputSelect/InputSelect";
import Dog from "../../../assets/Dog.svg";
import Cat from "../../../assets/Cat.svg";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const First = ({ formData, setFormData, onValidationChange, mode = 'wizard' }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.species);
  }, [formData.species, onValidationChange]);

  const handleSpeciesChange = (species: "cat" | "dog") => {
    setFormData({
      ...formData,
      breed_id: null,
      species
    });
  };

  if (mode === 'validation') {
    return (
      <InputSelect
        label={t("animalInfo:PROFIL_VALIDATION.SPECIES")}
        datas={[
          { label: t("animalInfo:QUESTION_ONE.CAT"), value: "cat" },
          { label: t("animalInfo:QUESTION_ONE.DOG"), value: "dog" },
        ]}
        value={formData.species ?? ""}
        onChange={(event) => handleSpeciesChange(event.target.value as "cat" | "dog")}
      />
    );
  }

  return (
    <>
      <TouchButton
        text={t("animalInfo:QUESTION_ONE.CAT")}
        active={formData.species === "cat"}
        logoPath={Cat}
        onClick={() => handleSpeciesChange("cat")}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_ONE.DOG")}
        active={formData.species === "dog"}
        logoPath={Dog}
        onClick={() => handleSpeciesChange("dog")}
      />
    </>
  );
};

export default First;
